<template>
    <CieloLayout>
        <div class="d-flex flex-column flex-fill">
            <TitleText class="spacing-b-6" level="2">
                {{ $ml.get('titleViewQrCodeCred') }}
            </TitleText>

            <div class="d-flex flex-column flex-fill">
                <router-view />
            </div>
        </div>
    </CieloLayout>
</template>
  
<script>
    const CieloLayout = () =>
        import(
        /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
        );
    import TitleText from '@/components/template/TitleText';

    export default {
        components: {
            CieloLayout,
            TitleText
        },
        data() {
            return {
                loading: false,
            };
        },
    };
</script>
  
<style scoped>
</style>